import PropTypes from 'prop-types';
import React from 'react';

const DetalhesOrigem = ({ origem }) => (
  <>
    <p>
      <b>Expedidor</b>
    </p>
    <p>
      <b>Cliente: </b>
      <span>
        {origem.nome_expedidor ? origem.nome_expedidor : 'Não informado'}
      </span>
    </p>
    <p>
      <b>Cidade: </b>
      <span>
        {origem.cidade_expedidor
          ? `${origem.cidade_expedidor} - `
          : 'Não informado'}
      </span>
      <span>{origem.estado_expedidor ? origem.estado_expedidor : ''}</span>
    </p>
    <br />
    <p>
      <b>Remetente</b>
    </p>
    <p>
      <b>Cliente: </b>
      <span>
        {origem.nome_remetente ? origem.nome_remetente : 'Não informado'}
      </span>
    </p>
    <p>
      <b>Cidade: </b>
      <span>
        {origem.cidade_remetente
          ? `${origem.cidade_remetente} - `
          : 'Não informado'}
      </span>
      <span>{origem.estado_remetente ? origem.estado_remetente : ''}</span>
    </p>
  </>
);

DetalhesOrigem.propTypes = {
  origem: PropTypes.shape({
    nome_expedidor: PropTypes.string,
    cidade_expedidor: PropTypes.string,
    estado_expedidor: PropTypes.string,
    nome_remetente: PropTypes.string,
    cidade_remetente: PropTypes.string,
    estado_remetente: PropTypes.string,
  }),
};

DetalhesOrigem.defaultProps = {
  origem: {},
};

export default DetalhesOrigem;
